/**
 * Import necessary dependencies for a React component that uses Bootstrap and internationalization.
 * @module ReactDependencies
 * @requires React
 * @requires Breadcrumb from react-bootstrap
 * @requires useTranslation from react-i18next
 */
import React from "react";
import { Breadcrumb } from "react-bootstrap";
import { useTranslation } from "react-i18next";

/**
 * A component that renders breadcrumbs for navigation.
 * @param {Object} props - The props object containing the following properties:
 *   - {Function} backPageFunction - The function to call when the back button is clicked.
 *   - {boolean} breadcrumbInner - Whether to render the inner breadcrumb section.
 *   - {boolean} breadcrumbMainTitle - Whether to render the main breadcrumb title.
 *   - {string} innerPagetitle - The title of the inner breadcrumb section.
 *   - {Object} style - The inline style object for the page title box.
 * @returns {JSX.Element} - The rendered Breadcrumbs component.
 */
const Breadcrumbs = (props) => {
  const {t} = useTranslation();
  

  /**
   * Destructures the properties object and assigns the values of the specified properties to
   * individual variables.
   * @param {object} props - The properties object.
   * @returns None
   */
  const { breadcrumbInner, breadcrumbMainTitle, innerPagetitle, backPageFunction, style, breadcrumbItem } = props

  /**
   * Renders a page title box with optional breadcrumb and back button functionality.
   * @param {Object} props - The component props.
   * @param {Object} props.style - The inline style for the page title box.
   * @param {string} props.breadcrumbItem - The text to display in the breadcrumb.
   * @param {boolean} props.breadcrumbMainTitle - Whether to display the breadcrumb main title.
   * @param {boolean} props.breadcrumbInner - Whether to display the breadcrumb inner title.
   * @param {string} innerPagetitle - The text to display as the inner page title.
   * @param {function} backPageFunction - The function to call when the back button is clicked.
   * @returns The rendered
   */
  return (
    <React.Fragment>
      <div
        className="page-title-box d-sm-flex align-items-center justify-content-between"
        style={style}
      >
        {breadcrumbMainTitle && 
        <h4 className="mb-0 font-size-18">{breadcrumbItem}</h4>
      }
        {breadcrumbInner && (
          <div className="page-title-left">
            <Breadcrumb listClassName="m-0">
            <div className="back-wrapper">
              <div className="Back_btn" onClick={backPageFunction}>
                <i className="mdi mdi-keyboard-backspace" />
              <h4 className="mb-0 font-size-18">{t("BACK")}</h4>
              </div>  
              <h4 className="mb-0 font-size-18">{innerPagetitle}</h4>
              </div>
            </Breadcrumb>
          </div>
        )}
      </div>
    </React.Fragment>
  );
};

export default Breadcrumbs;
